/**
 * @method getIDFromPK
 * @param {Number} pk - int of primary key
 * @param {String} nodeName - graphql node name
 * @returns {String} graphql id string
 */
const getIDFromPK = (pk, nodeName) => {
  if (!pk || !nodeName) {
    return;
  }

  return window.btoa(`${nodeName}:${pk}`);
};

export default getIDFromPK;
